// Payout calendar periods (docs/cashflow/SPEC.md, decision 11).
// period: { preset: 'next12' | 'year', year? }; dates are YYYY-MM-DD.
// "Last 12 months" (decision 27) and custom dates (decision 31) were removed: a saved one falls back to the default.

export const DEFAULT_PERIOD = { preset: 'next12' };

const PRESETS = ['next12', 'year'];

export function isValidPeriod(period) {
  return Boolean(period) && PRESETS.includes(period.preset)
    && (period.preset !== 'year' || Number.isInteger(period.year));
}

function parse(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

export function toIso(date) {
  return date.toISOString().slice(0, 10);
}

function addMonths(iso, months) {
  const date = parse(iso);
  date.setUTCMonth(date.getUTCMonth() + months);
  return toIso(date);
}

function addDays(iso, days) {
  const date = parse(iso);
  date.setUTCDate(date.getUTCDate() + days);
  return toIso(date);
}

export function localToday() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

// { from, to } inclusive.
export function periodRange(period, today) {
  switch (period.preset) {
    case 'year':
      return { from: `${period.year}-01-01`, to: `${period.year}-12-31` };
    default:
      // 12 whole months from the current one: what was already paid this month stays visible
      // and counts toward the goal (docs/cashflow/SPEC.md, decision 24).
      return { from: `${today.slice(0, 7)}-01`, to: addDays(addMonths(`${today.slice(0, 7)}-01`, 12), -1) };
  }
}

export function periodDays({ from, to }) {
  return Math.round((parse(to) - parse(from)) / 86400000) + 1;
}

// Chart buckets: months, or years for periods longer than 24 months (decision 18).
export function periodBuckets({ from, to }) {
  const months = (Number(to.slice(0, 4)) - Number(from.slice(0, 4))) * 12 + Number(to.slice(5, 7)) - Number(from.slice(5, 7)) + 1;
  const buckets = [];
  if (months > 24) {
    for (let year = Number(from.slice(0, 4)); year <= Number(to.slice(0, 4)); year++) {
      buckets.push({ key: String(year), unit: 'year' });
    }
    return buckets;
  }
  let key = from.slice(0, 7);
  for (let i = 0; i < months; i++) {
    buckets.push({ key, unit: 'month' });
    key = addMonths(`${key}-01`, 1).slice(0, 7);
  }
  return buckets;
}
